var $0f0e6467596070ec$exports = {};
$0f0e6467596070ec$exports = {
    "backButton": (args)=>`Retour vers ${args.prevMenuButton}`,
    "moreActions": `Autres actions`,
    "unavailable": `Indisponible, d\xe9velopper pour plus de d\xe9tails`
};


export {$0f0e6467596070ec$exports as default};
//# sourceMappingURL=fr-FR.module.js.map
